import { format } from "date-fns";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../common/Table/Table";
import styles from "./RecentTransactions.module.scss";
import Button from "../../../../common/Button/Button";
import Select from "../../../../common/Formik/Select/Select";
import NoContent from "../../../../common/NoContent/NoContent";
import { useDebounce } from "../../../../customHook/useDebeunce";
import InputFormik from "../../../../common/Formik/Input/InputFormik";
import Commonpagination from "../../../../common/Pagination/Commonpagination";
import CommonDatePicker from "../../../../common/Formik/DatePiker/DatePicker";
import { GreenArrowIcon, RedArrowIcon } from "../../../../../assets/icons/svgicons";
import { cardDetailsAction, cardTranstionAction } from "../../../../../features/user/userSlice";

const RecentTransactions = () => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const debounced = useDebounce(search, 500);
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const cardType = localStorage.getItem("cardType");
  const [cardDetails, setCardDetails] = useState({});
  const [cardtransaction, setTransactionData] = useState([]);
  const [filter, setFilter] = useState({ value: "All", label: "All" });

  const cardId = cardType === "CREDIT" ? cardDetails?.credit?.rain_card_id : cardDetails?.debit?.rain_card_id;

  const cardTranstionData = async () => {
    if (!cardId) return;
    try {
      setLoading(true)
      const data = {
        page: page,
        limit: 10,
        ...(debounced && { search: debounced }),
        ...(filter?.value !== "All" && { transactionType: filter.value }),
        ...(startDate && endDate && {
          startDate: format(new Date(startDate), "yyyy-MM-dd"),
          endDate: format(new Date(endDate), "yyyy-MM-dd"),
        }),
      };
      const res = await dispatch(cardTranstionAction(cardId, data));
      if (res.status === 200) {
        const fullList = res?.data?.data || [];
        setTransactionData(fullList);
      }
    } catch (error) {
      console.log("Error");
    } finally {
      setLoading(false)
    }
  };

  // ********** GET CARD DETAILS **********
  const getCardDetails = async () => {
    try {
      const res = await dispatch(cardDetailsAction());
      if (res?.status === 200) {
        const cards = res?.data?.data || [];
        const debit = cards.find((c) => c.card_type === "DEBIT");
        const credit = cards.find((c) => c.card_type === "CREDIT");
        setCardDetails({ debit: debit, credit: credit })
      } else {
        setCardDetails({});
      }
    } catch (error) {
      console.log(error, "error");
    }
  }

  useEffect(() => {
    getCardDetails()
  }, [])

  useEffect(() => {
    if (cardId) {
      cardTranstionData()
    }
  }, [cardId, page, debounced, filter, startDate, endDate]);


  const options = [
    { value: "All", label: "All" },
    { value: "load", label: "Top Up" },
    { value: "spend", label: "Spend" },
  ];

  const fields = [
    { label: "Transaction Id", value: "amount" },
    { label: "Amount", value: "bill_number" },
    { label: "Transaction Status", value: "paid_amount" },
    { label: "Type", value: "paid_amount" },
    { label: "Date & Time", value: "previous_balance" },
  ]

  const handleResetDates = () => {
    setStartDate("");
    setEndDate("");
  };

  return (
    <>
      <div className={styles.recent_transactions_head}>
        <h2>
          Recent {cardType === "CREDIT" ? "Credit" : "Debit"} Transactions
        </h2>
        <div className={styles.recent_transactions_head_right}>
          <InputFormik
            name="amount"
            value={search}
            variant="large_height"
            className="fieldinput"
            placeholder="Enter Transaction ID"
            onChange={(e) => setSearch(e.target.value)}
          />
          <Select
            className="select_time"
            name="filter"
            placeholder={<h6>Select Country</h6>}
            options={options}
            value={filter}
            onChange={(value) => setFilter(value)}
            isSearchable
          />
          <Formik
            initialValues={{
              startdate: "",
              enddate: "",
            }}
          >
            {(formik) => (
              <form className={styles.formDate} onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                <CommonDatePicker
                  className="formDatePicker"
                  name="startdate"
                  value={startDate}
                  placeholder="Start Date"
                  onChange={(date) => setStartDate(date)}
                  // minDate={new Date()}
                  formik={formik}
                />
                <CommonDatePicker
                  className="formDatePicker"
                  name="enddate"
                  value={endDate}
                  placeholder="End Date"
                  onChange={(date) => setEndDate(date)}
                  // minDate={new Date()}
                  formik={formik}
                />
                <Button
                  className={styles.resetBtn}
                  variant='xtra_small danger_filled'
                  type="button"
                  onClick={(e) => {
                    handleResetDates(formik);
                  }}
                  disabled={!startDate && !endDate}
                >
                  Reset
                </Button>
              </form>
            )}
          </Formik>
        </div>
      </div>
      <Table
        noRecordContent={"No records for your search were found."}
        fields={fields}
        className='table'
        loading={loading}
        noRecordVariant={"large"}
        noRecordClassName={styles.no_content}
        loadingClassName={"loading_table"}
      >
        {cardtransaction?.transactions?.length > 0 ?
          cardtransaction?.transactions?.map((item, index) => (
            <tr key={index}>
              <td>
                {item?.external_transaction_id
                  ? item.external_transaction_id
                  : item?.id}
              </td>
              <td>
                {item?.amount}
                &nbsp;
                <span>{item?.transaction_type_api === "spend" ? <RedArrowIcon /> : <GreenArrowIcon />}</span>
              </td>
              <td>{item?.transaction_status}</td>
              <td>{item?.transaction_type_api === "load" ? "Top Up" : "Spend"}</td>
              <td>{item?.created_at &&
                !isNaN(
                  new Date(item?.created_at).getTime()
                )
                ? format(
                  new Date(item?.created_at),
                  "dd MMM, yyyy hh:mm a"
                )
                : "Invalid date"}</td>
            </tr>
          )) :
          <tr>
            <td colSpan={fields.length}>
              <NoContent
                className={styles.no_record}
              />
            </td>
          </tr>
        }
      </Table>
      {cardtransaction?.pagination?.total_pages > 1 && (
        <Commonpagination
          pagination
          currentPage={page}
          className={styles.pagination}
          pageSize={10}
          totalPages={cardtransaction?.pagination?.total_pages}
          handlePageChange={(selected) => setPage(selected)}
        />
      )}
    </>
  );
};

export default RecentTransactions;
